import { PHP_API_URL } from "../../util/constants";
import request from "../../util/request";

export function getVideoPlayerAuthRequest(VideoId, callback) {
    let formData = new FormData();
    // formData.append('caozuo', "xuexi_shiti");
    formData.append('VideoId', VideoId);
    return request(PHP_API_URL+"/aliyun/getplayauth.php", {
        method: "POST",
        body: formData
    }, callback);
}